var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArticleLayout',{attrs:{"color":"#65b4bd","title":"商业合作","data":_vm.textData}})}
var staticRenderFns = []

export { render, staticRenderFns }